import { render } from "./BulkRTPAssignment.vue?vue&type=template&id=42698174&scoped=true"
import script from "./BulkRTPAssignment.vue?vue&type=script&lang=js"
export * from "./BulkRTPAssignment.vue?vue&type=script&lang=js"

import "./BulkRTPAssignment.vue?vue&type=style&index=0&id=42698174&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42698174"]])

export default __exports__